class CartController {
    constructor($scope, moveFocus, sessionStorage, settings, analyticsService, breakpointsService, trolleyService, addressService, fulfilmentService, shopperService) {
        this.scope = $scope;
        this.moveFocus = moveFocus;
        this.sessionStorage = sessionStorage;
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.breakpointsService = breakpointsService;
        this.trolleyService = trolleyService;
        this.addressService = addressService;
        this.fulfilmentService = fulfilmentService;
        this.shopperService = shopperService;
    }

    $onInit() {
        const sessionStorageKey = 'wowCart:collectionZoneMessages';
        const saveCartAsListMessageSessionStorageKey = 'shouldOpenCartToShowSaveListMessage';
        const savedMessages = this.sessionStorage.getJsonAndRemove(sessionStorageKey);

        if (!this.shopperService.IsGuest && savedMessages) {
            this.cartMessages = savedMessages;
        }

        this.scope.$on('login:success', (ev, loginResult) => {
            if (loginResult.HasCollectionZoneMessages) {
                // Save collection zone messages to session storage
                this.sessionStorage.setJson(sessionStorageKey, loginResult.LoginCollectionZoneMessages);

                // Set the cart to be open after user logs in when there is a message needs to be shown
                this.sessionStorage.setJson(saveCartAsListMessageSessionStorageKey, true);
            }
        });

        this.showClearTrolleyConfirmationMessage = false;

        // push cart data in $onInit when website is in small format
        if (!this.breakpointsService.isInGreaterThanMediumFormatLandscape) {
            this.pushDataToAnalyticsService();
        }
    }

    $onChanges(changes) {
        // push cart data in when cart is opened in medium and large format. Changes in cart panel is passed as a binding.
        if (this.breakpointsService.isInGreaterThanMediumFormatLandscape && changes.isOpen && changes.isOpen.currentValue) {
            this.pushDataToAnalyticsService();
        }
    }

    getProductsNotAvailableAtLocationMessage() {
        return this.fulfilmentService.selectedFulfilmentMethod === this.fulfilmentService.fulfilmentOptions.delivery ?
            this.settings.trolley.productsUnavailableAtDeliveryLocation :
            this.settings.trolley.productsUnavailableAtPickupLocation;
    }

    pushDataToAnalyticsService() {
        this.analyticsService.push({
            data: {
                products: this.trolleyService.trolleyProducts,
                savedPrice: this.trolleyService.savedPrice,
            },
            type: this.analyticsService.mapperTypes.shop.cart,
        });
    }

    showTrolleyConfirmationContainerActions() {
        this.showClearTrolleyConfirmationMessage = true;
        this.moveFocus('#_cancelRemoveCartItems');
    }

    clearCart() {
        this.trolleyService.clearTrolley();
        this.showClearTrolleyConfirmationMessage = false;
        this.analyticsService.push({
            data: {
                trackingType: 'link',
            },
            type: this.analyticsService.mapperTypes.customEvent.trolley.clear,
        });
    }

    clearOutOfStock() {
        this.trolleyService.clearOutOfStockTrolleyItems();
    }

}

const cartComponentDefinition = {
    bindings: {
        isOpen: '<?',
        isPage: '<?',
    },
    controller: ['$scope', 'MoveFocus', 'SessionStorageWrapper', 'Settings', 'AnalyticsService', 'BreakpointsService', 'TrolleyService', 'AddressService', 'FulfilmentService', 'ShopperService', CartController],
    template: require('./cart.component.html').trim(),
};

module.exports = {
    CartController,
    cartComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart.component.js